import { render, staticRenderFns } from "./CreateRomaneioView.vue?vue&type=template&id=d39246a2"
import script from "./CreateRomaneioView.vue?vue&type=script&lang=js"
export * from "./CreateRomaneioView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports